<template>
  <footer class="wt2-sg">
    <wt-button type="transparent" @click="cancel" text="Close" />
    <wt-button
      type="primary"
      @click="$_onAddFragment"
      :text="addFragmentText"
      :disabled="applyDisabled"
    />
  </footer>
</template>

<script>
import bus from 'v/AssetEditor/AssetEditorEventBus';
export default {
  props: {
    selectedAllVideo: { type: Boolean, required: true },
    applyDisabled: { type: Boolean, default: false },
    openedFrom: {
      type: String,
      default: 'timeline',
    },
  },

  data() {
    return {
      animeDuration: 750,
      addMoreAnime: false,
    };
  },

  beforeDestroy() {
    this.$_animeTimer.stop();
    bus.$off('fragment-added', this.$_onFragmentAdded);
  },

  mounted() {
    this.$_animeTimer = new app.namespace.Util.Timer(
      this.$_onAddMoreAnime,
      this.animeDuration
    );
    bus.$on('fragment-added', this.$_onFragmentAdded);
  },

  methods: {
    cancel: function () {
      this.$emit('close');
    },

    $_onAddFragment: function () {
      this.$emit('addFragment', {
        andClose: this.$props.selectedAllVideo,
      });
    },

    $_onFragmentAdded() {
      this.addMoreAnime = true;
      this.$_animeTimer.start();
    },

    $_onAddMoreAnime() {
      this.addMoreAnime = false;
    },
  },

  computed: {
    addFragmentText() {
      return this.openedFrom === 'timeline-change-segment'
        ? 'Replace Segment'
        : this.addMoreAnime
        ? app.culture.get('assetEditor.addSegmentAnime')
        : app.culture.get('assetEditor.addSegmentStatic');
    },
  },
};
</script>
